<template>
    <v-dialog v-model="dialogModel" max-width="700">
        <div class="elevation-5 card" style="margin: 0;">
            <v-form :lazy-validation="true" ref="form" v-model="valid">
                <v-layout column>
                    <v-flex>
                        <h2>Agregar Columna a tabla de productos</h2>
                    </v-flex>
                    <v-flex class="form-component">
                        <v-layout row>
                            <v-flex>
                                <v-select class="lance"
                                    v-model="form.field"
                                    label="Nombre de Columna"
                                    attach
                                    :items="remainingTableFields"
                                    :rules="[v => !!v || 'Campo requerido']"
                                ></v-select>
                            </v-flex>
                            <v-flex grow="false" shrink="false">
                                <v-switch class="lance"
                                    style="margin-top: 10px;"
                                    v-model="form.isOptional"
                                    color="primary"
                                    label="Es Opcional"
                                ></v-switch>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex>
                        <v-text-field class="lance"
                            v-model="form.reference"
                            label="Referencia"
                            :rules="[v => !!v || 'Campo requerido']"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="form-component">
                        <v-select class="lance"
                            v-model="form.format"
                            :items="formatItems"
                            label="Formato"
                        ></v-select>
                    </v-flex>
                    <v-flex>
                        <h4>Posición de la columna</h4>
                    </v-flex>
                    <v-layout row>
                        <v-flex>
                            <v-text-field class="lance"
                                type="number"
                                label="Desde"
                                v-model="tableCoords.x1"
                                :min="0"
                                :rules="rules.px1"
                            ></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-text-field class="lance"
                                type="number"
                                label="Hasta"
                                v-model="tableCoords.x2"
                                :min="0"
                                :rules="rules.px1"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-flex v-if="isPosition">
                        <ImageSelect
                            v-if="imageSelection"
                            style="width:100%;" 
                            v-model="tableCoords"
                            :imgSrc="imageSelection"/>
                    </v-flex>
                    <v-flex v-if="!isPosition">
                        <v-text-field
                            class="lance"
                            label="Columna"
                            v-model="form.column"
                        ></v-text-field>
                    </v-flex>
                    <v-flex style="display: flex;">
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" flat @click="cancel">Cancelar</v-btn>
                        <v-btn
                            solo
                            color="submitBtn"
                            @click="doAction"
                            :disabled="!valid"
                            style="color: white;"
                            >Agregar</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </div>
    </v-dialog>
</template>

<script>
import ImageSelect from "./ImageSelect";
export default {
    props: [
        "value",
        "imageSelection",
        "isPosition",
        "remainingTableFields",
        "editData"
    ],
    data() {
        return {
            action: null,
            valid: null,
            dialogModel: this.value,
            form: {
                field: null,
                reference: null,
                format: null,
                x1: 0,
                x2: 0,
                column: null,
            },
            tableCoords: { x1: 0, y1: 0, x2: 0, y2: 0 },
            formatItems: [
                "Numerico",
                "Texto Libre",
                "Moneda",
            ],
            rules: {
                px1: [
                    val => val >= 0 || "Debe ser mayor o igual a cero"
                ]
            }
        };
    },
    methods: {
        doAction() {
            if(this.$refs.form.validate()) {
                this.$refs.form.resetValidation();
                this.$emit(this.action, this.form);
            }
        },
        cancel() {
            this.$refs.form.resetValidation();
            this.$emit("cancel");
        },
    },
    mounted() {
        if (this.editData)  {
            this.action = "edit";
            Object.assign(this.form, this.editData);
            this.tableCoords = {
                x1: this.editData.x1,
                y1: 10,
                x2: this.editData.x2,
                y2: 150,
            }
        } else {
            this.action = "add";
        }
    },
    watch: {
        "dialogModel": function(newVal) { this.$emit("input", newVal); },
        "value": function(newVal) { this.dialogModel = newVal; },
        "tableCoords.x1": function(newVal) { this.form.x1 = newVal; },
        "tableCoords.x2": function(newVal) { this.form.x2 = newVal; },
    },
    components: {
        ImageSelect,
    },
}
</script>

<style scoped>
    .layout {
        margin: -8px !important;
    }
    .flex {
        padding: 8px !important;
    }
    .card {
        background-color: white;
        border-radius: 16px;
        margin-bottom: 28px;
        padding: 40px;
    }
    .v-input.v-input--switch {
        display: inline-flex;
    }
</style>
